/**
 * MouseUtil.js
 * 
 * Created on 23-sep-2013
 * 
 * @author Reinier Feijen for Ranj
 * @author Harm Boschloo for Ranj
 **/
class MouseUtil {
    static hasMouseEventListeners(target, checkChildren) {
        if (arguments.length <= 1) {
            checkChildren = true;
        }

        for (var i = 0; i < MouseUtil.EVENT_TYPES.length; ++i) {
            if (target.hasEventListener(MouseUtil.EVENT_TYPES[i])) {
                return true;
            }
        }

        if (checkChildren && target.children) {
            for (var i = 0; i < target.children.length; ++i) {
                if (MouseUtil.hasMouseEventListeners(target.children[i], checkChildren)) {
                    return true;
                }
            }
        }

        return false;
    };

    static showPointer(show) {
        document.body.style.cursor = show ? "pointer" : "default";
    };
}

MouseUtil.EVENT_TYPES = ["click", "dblclick", "mousedown", "pressup", "pressmove", "mouseout", "mouseover", "rollover", "rollout"];

export default MouseUtil;